export default "__VITE_ASSET__6d0db27d__"